module.exports = __webpack_public_path__ + "img/map_3f@2x.2ff2303c.png";